import React, {ComponentProps} from 'react'

import {flattenDeep} from 'es-toolkit'
import {isFragment} from 'react-is'

export const mapChildrenWithFragments = <P, T = React.ReactElement<P>>(
  children: React.ReactNode,
  iterator: (child: React.ReactElement<P>, index: number) => T = child => child as T
) =>
  flattenDeep(
    React.Children.toArray(children).map(child => {
      if (isFragment(child)) {
        return React.Children.toArray(
          (child as React.ReactElement<ComponentProps<typeof React.Fragment>>).props.children
        )
      }
      return child
    })
  )
    .filter(child => React.isValidElement(child))
    .map((child, index) => iterator(child as React.ReactElement<P>, index))

export const countChildrenWithFragments = (children: React.ReactNode) =>
  mapChildrenWithFragments(children, child => child).length
